<template>
  <div style="width: calc(100% - 70px); height: calc(100% - 20px)">
    <div style="height: 100%">
      <Assets
        :containerHeight="'calc(100% - 20px) !important'"
        v-if="true"
        :selectMode="true"
        :dense="true"
        @selected="selectAssets" />
    </div>
  </div>
</template>
<script setup>
import { onMounted, defineProps, defineAsyncComponent } from 'vue';
import { state } from '../../../stores/deluge';

// Use dynamic import to avoid bundling Assets into main chunk
const Assets = defineAsyncComponent(() => import('../../Assets/Assets.vue'));

const props = defineProps([
  'customState',
  'userEditObj',
  'qid',
  'channel_did',
  'containerHeight',
]);

function selectAssets(newVal) {
  props.customState.asset_ids = newVal;
}

onMounted(() => {
  console.log('mounted tab 1: Create Scene From Assets');
});
</script>

<style scoped></style>
